import { useCallback } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useConfirm from 'src/hooks/useConfirm';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import useDeleteReceiptsApi from 'src/services/useDeleteReceiptApi';

const DeleteReceipt = () => {
  const { deleteReceipts, deleteReceiptsLoading } = useDeleteReceiptsApi();
  const { confirm } = useConfirm();
  const { receiptData, recId, refreshPage } = useReceiptDetails();

  const { deleteReceipt } = receiptData;

  const handleDelete = useCallback(async () => {
    try {
      const isDeleteApproved = await confirm({
        title: `Delete Receipt`,
        content: `Are you sure you want to Delete this receipt?`,
        confirmButtonText: 'OK',
      });
      if (isDeleteApproved) {
        await deleteReceipts({ receiptIds: [recId] });
      }
    } catch (error) {
      console.error(error);
    } finally {
      refreshPage();
    }
  }, [confirm, deleteReceipts, recId, refreshPage]);

  return (
    <PopUp
      content={<PopUpContentWrapper type="Error" contents={[]} />}
      show={isButtonDisabled(deleteReceipt)}
    >
      <Button
        onClick={handleDelete}
        loading={deleteReceiptsLoading}
        color="error"
        buttonState={deleteReceipt}
        disabled={isButtonDisabled(deleteReceipt)}
      >
        Delete
      </Button>
    </PopUp>
  );
};
export default DeleteReceipt;
